import React, { FC } from 'react';
import classNames from 'classnames';
import View from '../view';
import { pxTransform } from '../../common/utils';

export interface IIconProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 图标名称或图片链接
   */
  name?: string;
  /**
   * 图标尺寸，此属性传入值为 number 时, 调用 Taro.pxTransform(size) 计算尺寸; 当传入的 name 为图标名称时，无默认值；当 传入的 name 为图片链接时，默认值为 48
   */
  size?: number | string;
  /**
   * 图标颜色
   */
  color?: string;
}

const getIconSize = (size?: number | string, isImage = false) => {
  if (typeof size === 'undefined') {
    return isImage ? pxTransform(48) : undefined;
  }
  return typeof size === 'number' ? pxTransform(size) : size;
};

const Icon: FC<IIconProps> = ({ className = '', name = '', size, color }) => {
  const isImage = name.indexOf('/') !== -1;
  const iconSize = getIconSize(size, isImage);
  const rootClass = classNames(
    'ink-icon',
    {
      [`ink-icon-${name}`]: !isImage,
    },
    className,
  );
  const rootStyle = {
    ...(iconSize ? { fontSize: iconSize } : undefined),
    ...(color ? { color } : undefined),
    ...(isImage ? { background: `url(${name}) center / contain no-repeat`, width: iconSize, height: iconSize } : undefined),
  };
  return <View className={rootClass} style={rootStyle} />;
};

export default Icon;
